import { ActionItemInterface } from './ActionItemInterface';

export class PolicyLink {
  modalName?: string;
  constructor(public displayText: string, public linkHref?: string, public actionItem?: ActionItemInterface) {}
}

export class PolicyModal extends PolicyLink {
  constructor(displayText: string, modalName: string) {
    super(displayText, '');
    this.modalName = modalName;
  }
}
